/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Formatting_TitleInputs */

const en_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Display Formatting`)
};

const fr_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme de l'affichage`)
};

const de_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigeformatierung`)
};

const it_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione dello schermo`)
};

const ru_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форматирование отображения`)
};

const es_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de visualización`)
};

const zh_cn2_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示格式`)
};

const ja_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示フォーマット`)
};

const hi_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डिस्प्ले फ़ॉर्मेटिंग`)
};

const pt_pt2_options_display_formatting_title = /** @type {(inputs: Options_Display_Formatting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação de exibição`)
};

/**
* | output |
* | --- |
* | "Display Formatting" |
*
* @param {Options_Display_Formatting_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_formatting_title = /** @type {((inputs?: Options_Display_Formatting_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Formatting_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_display_formatting_title(inputs)
	if (locale === "de") return de_options_display_formatting_title(inputs)
	if (locale === "it") return it_options_display_formatting_title(inputs)
	if (locale === "ru") return ru_options_display_formatting_title(inputs)
	if (locale === "es") return es_options_display_formatting_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_display_formatting_title(inputs)
	if (locale === "ja") return ja_options_display_formatting_title(inputs)
	if (locale === "hi") return hi_options_display_formatting_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_display_formatting_title(inputs)
	return en_options_display_formatting_title(inputs)
});